module.exports = __webpack_public_path__ + "static/media/shape.caff0e9d.svg";